import React from "react";
import { FormattedMessage } from "react-intl";
import { UncontrolledTooltip } from "reactstrap";
import RaangeTooltip from "../../components/RaangeTooltip";

export default () => (
  <RaangeTooltip
    tag="span"
    tooltip={(target) => (
      <UncontrolledTooltip placement="right" target={target}>
        <FormattedMessage id="form.tooltips.web_link" />
      </UncontrolledTooltip>
    )}
  >
    <a href="###">
      <i className="fas fa-question-circle fa-fw" />
    </a>
  </RaangeTooltip>
);
